import React, { useState, useContext, useEffect, Fragment } from "react";
//import Button from '../../lib/ui/buttons/Button';
import Button from "../../../../lib/ui/buttons/Button";
import InputField from '../../../../lib/ui/inputs/Input';
import Radio from '../../../../lib/ui/radio/Radio';
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css'
import { LangCtx } from "../../../../lib/context";
//import { langObj } from "../../../../locale/index";
import '../../../../lib/ui/imageicon/Styles.css';
import "../../../../layouts/Layouts.css";
import "../../../../ui-styles/picker/picker.css";
import Loader from "../../../../lib/ui/loader/Loader";
import DropDown from "../../../../lib/ui/dropdown/Dropdown";
import AddrDropDown from "../../../../lib/ui/dropdown/addressDropDown";
import { createUser, updateUser, getallClinics, getUserDetails, getAllAdmins } from "../../../../actions/users";
import { useHistory } from 'react-router-dom';
import { validateEmail, validateDate, validateLetters, validatePincode, valPnBoCc } from '../../../../lib/validation';
import titlesList from "../../../../config/titles.json";
import bloodgroups from "../../../../config/bloodgroup.json";
import statesList from "../../../../config/states.json";
import citiesList from "../../../../config/cities.json";
import countriesList from "../../../../config/countries.json";
import DateFnsUtils from '@date-io/date-fns';
import { toast } from 'react-toastify';
import VerifyPopup from "../../users/components/VerifyPopup";
// import config from '../../../../config.json';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
// const psl = require('psl');
import { API } from 'aws-amplify';

//const titlesList = [{value: "", label:"Select"},{value: "Mr", label:"Mr."}, {value: "Mrs", label:"Mrs."}, {value: "Ms", label:"Ms."},{value: "Master", label:"Master"}, {value: "Miss", label:"Miss"}]
//const usertype = [{ value: "", label: "-- Select User Type --" }, { value: "CL", label: "Clinic" }, { value: "DO", label: "Doctor" }, { value: "PT", label: "Patient" },]
//const clinicList = [{ value: "", label: "-- Assigned Clinic --" }, { value: "cl1", label: "Clinic One" }, { value: "cl2", label: "Clinic Two" }, { value: "cl3", label: "Clinic Three" },]

const CreatePatientForm = (props) => {
    const { l } = useContext(LangCtx);
    const { role, userId } = props;
    const history = useHistory();
    const pId = props.pId;
    const [loading, setLoading] = useState(false);

    const [errorMsg, setErrorMsg] = useState(null);
    const [error, setError] = useState({});
    const [firstName, setfirstName] = useState('');
    const [lastName, setLastName] = useState('');
    //    const [civilNumber, setCivilNumber] = useState('');
    const [dob, setDob] = useState(new Date());
    const [email, setEmail] = useState('');
    const [gender, setGender] = useState('');
    const [bloodgroup, setBloodgruop] = useState('');
    const [referredBy, setReferredBy] = useState('');
    const [phone, setPhone] = useState('');
    const [states, setStates] = useState([{
        value: "",
        label: l.select_state
    },]);
    const [cities, setCities] = useState([{
        value: "",
        label: l.select_city
    },]);
    const [address, setAddress] = useState('');
    const [country, setCountry] = useState('India');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [pincode, setPincode] = useState('');
    const [clinics, setClinics] = useState([]);
    const [clinic, setClinic] = useState('');
    const [openPopup, setopenPopup] = useState(false)
    const [admins, setAdmins] = useState([]);
    const [adminId, setAdminId] = useState(null);
    const [domainName, setDomainName] = useState(process.env.REACT_APP_defaultdomian);
    // const _domain = psl.parse(window.location.hostname);
    const [title, setTitle] = useState('');

    useEffect(() => {
        if (role === "SA") {
            getAllAdmins().then(res => {
                let _admins = [{
                    value: "",
                    label: l.select_admin
                }]
                res.data.forEach(ad => {
                    _admins.push({
                        label: ad.companyName,
                        value: ad.userId
                    })
                });
                setAdmins(_admins);
            }).catch(err => {
                console.log("err in all admin ==== ", err);
            })
        } else if (role === "CA") {
            setAdminId(userId)
        }
    }, [role, userId]);

    useEffect(() => {
        if (role === "CA") {
            let qr = role === "C" ? `&clinicId=${userId}` : '';
            getallClinics(qr).then(res => {
                if (res.status) {
                    let _clinics = []
                    res.data.forEach(clinic => {
                        let _clinic = {
                            label: clinic.clinicName,
                            value: clinic.userId
                        }
                        _clinics.push(_clinic)
                    });
                    _clinics.unshift({
                        value: "",
                        label: l.select_clinic
                    });
                    setClinics(_clinics);
                }
            }).catch(err => {
                console.log("err ==== ", err);
            });
        }
        if (pId) {
            setLoading(true);
            getUserDetails(pId).then(res => {
                setLoading(false);
                if (res.status) {
                    setTitle(res.data.title);
                    setfirstName(res.data.firstName);
                    setLastName(res.data.lastName);
                    //    setCivilNumber(res.data.civilNumber);
                    setDob(res.data.dob);
                    setEmail(res.data.email);
                    setGender(res.data.gender);
                    setPhone(res?.data?.countryCode ? `+${res?.data?.countryCode}${res?.data?.phone}` : res.data.phone);
                    setBloodgruop(res.data.bloodgroup);
                    setReferredBy(res.data.referredBy);
                    setAddress(res.data.address);
                    setCountry(res.data.country);
                    setState(res.data.stateName);
                    setCity(res.data.city);
                    setPincode(res.data.pincode);
                    // handleStates(res.data.stateName);
                    // handleCities(res.data.city);
                    setClinic(res.data.clinicId);
                    setDomainName(res.data.subdomain);
                    //      setState(res.data.state);
                }
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
            });
        }
    }, [props.active, pId, l, role]);

    useEffect(() => {
        let _statesList = statesList.filter((state) => state.countryid === country);
        if (_statesList.length === 0) {
            _statesList = [{
                value: "",
                label: l.no_states_available
            }];
        } 
        _statesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
        setStates([..._statesList]);
        setCity(''); 
        // setCities([{ value: "", label: l.select_city }]);
    }, [country]);

    useEffect(() => {
        let _citiesList = citiesList.filter((city) => city.stateid === state);
        if (_citiesList.length === 0) {
            _citiesList = [{
                value: "",
                label: l.no_cities_available
            }];
        } 
        // else {
        //     _citiesList.unshift({
        //         value: "",
        //         label: l.select_city
        //     });
        // }
        _citiesList.sort((a,b)=> a.value < b.value? -1:a.value > b.value? 1:0)
        setCities(_citiesList);
    }, [state]);

    // const handleStates = (country) => {
    //     setCountry(country);
    //     if (country) {
    //         let _statesList = statesList.filter((state) => {
    //             return state.countryid === country
    //         });
    //         _statesList.unshift({
    //             value: "",
    //             label: l.select_state
    //         });
    //         setStates([..._statesList]);
    //     }
    // }

    // const handleCities = (state) => {
    //     setState(state);
    //     if (state) {
    //         let _citiesList = citiesList.filter((city) => {
    //             return city.stateid === state
    //         });
    //         _citiesList.unshift({
    //             value: "",
    //             label: l.select_city
    //         });
    //         setCities(_citiesList);
    //     }
    // }

    const handleCancel = () => {
        history.push('/admin-users/patient');
    }

    const validateForm = () => {
        let _error = {};
        let returnValue = true;

        if (title === '' || title === null) {
            _error['title'] = l.pls_ent_title
            returnValue = false
        }
        if (firstName === '' || firstName === null) {
            _error['firstName'] = l.pls_ent_fName
            returnValue = false
        }
        else if (!validateLetters(firstName)) {
            _error['firstName'] = l.pls_ent_letters_fName
            returnValue = false;
        }
        if (lastName === '' || lastName === null) {
            _error['lastName'] = l.pls_ent_lName
            returnValue = false
        }
        else if (!validateLetters(lastName)) {
            _error['lastName'] = l.pls_ent_letters_lName
            returnValue = false;
        }
        if (referredBy !== "" && !validateLetters(referredBy)) {
            _error['referredBy'] = l.pls_ent_letters_rBy
            returnValue = false;
        }
        if (gender === '' || gender === null) {
            _error['gender'] = l.pls_sel_gender
            returnValue = false
        }
        if (dob === '' || dob === null) {
            _error['dob'] = l.pls_sel_dob
            returnValue = false
        }
        else if (!validateDate(dob)) {
            _error['dob'] = l.pls_check_dob
            returnValue = false
        }
        if (email === '' || email === null) {
            _error['email'] = l.pls_enter_email;
            returnValue = false
        }
        else if (!validateEmail(email)) {
            _error['email'] = l.pls_check_email
            returnValue = false
        }
        if (phone === '' || phone === null) {
            _error['phone'] = l.pls_enter_phone
            returnValue = false
        }
        else if (!isValidPhoneNumber(phone)) {
            _error['phone'] = l.pls_check_phone
            returnValue = false
        }else if(!valPnBoCc(phone)){
            _error[ 'phone' ] = l.pls_check_phone;
            returnValue = false;
        }
        if (bloodgroup === '' || bloodgroup === null) {
            _error['bloodgroup'] = l.pls_sel_bldgp
            returnValue = false
        }
        // if (country === '' || country == null) {
        //     _error['country'] = l.pls_sel_country
        //     returnValue = false
        // }
        // if (state === '' || state == null) {
        //     _error['state'] = l.pls_sel_state
        //     returnValue = false
        // }
        // if (city === '' || city == null) {
        //     _error['city'] = l.pls_sel_city
        //     returnValue = false
        // }
        // if (pincode === '' || pincode == null) {
        //     _error['pincode'] = l.pls_entr_pin
        //     returnValue = false
        // }
        if (pincode && !validatePincode(pincode)) {
            _error['pincode'] = l.pls_check_pin
            returnValue = false
        }
         if (domainName === '' || domainName === null) {
            setErrorMsg(l.pls_entr_domain)
            returnValue = false
        }
        // else if (clinic === '' || clinic == null) {
        //     setErrorMsg(l.pls_sel_clc)
        //     return false
        // }
        /* else if (bloodgroup === '' || bloodgroup == null) {
             setErrorMsg(l.pls_sel_bloodgp)
             return false
         }*/
        setError(_error);
        return returnValue;
    }

    const handleCreatePatient = async (e) => {
        e.preventDefault();
        try {
            if (validateForm()) {
                setLoading(true);
                const phoneNumber = parsePhoneNumber(phone)
                const countrycode = phoneNumber.countryCallingCode;
                const number = phoneNumber.nationalNumber;
                let body = {
                    clinicId: role === "C" ? userId : clinic,
                    adminId: adminId,
                    //    clinic: clinic,
                    consultRole: 'patient',
                    title:title,
                    firstName: firstName.trim(),
                    lastName: lastName.trim(),
                    email: email.replaceAll(' ','').toLowerCase(),
                    countryCode: countrycode,
                    phone: number,
                    //       civilNumber: civilNumber,
                    gender: gender.trim(),
                    dob: new Date(dob).valueOf(),
                    bloodgroup: bloodgroup,
                    referredBy: referredBy,
                    address: address ? address : '',
                    country: country ? country : '',
                    stateName: state ? state : '',
                    city: city ? city : '',
                    pincode: pincode? pincode: '',
                    // subdomain: role !== "C" ? domainName : _domain.subDomains && _domain.subDomains[0] ? _domain.subDomains[0] : _domain.hostname
                }
                if (pId) {
                    updateUser(pId, body).then(res => {
                        setLoading(false);
                        if (res.status) {
                            toast.success(l.upd_succ, {
                                position: toast.POSITION.TOP_RIGHT
                            })

                            history.push(`/clinic-users?pId=${pId}`);
                        }
                    }).catch(err => {
                        setLoading(false);
                        let msg = err?.response?.data?.error?.message ? err.response.data.error.message : err?.response?.data?.error ? err.response.data.error : l.unable_upd_patient;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        setErrorMsg(msg)
                    })
                } else {
                    createUser(body, role==="C").then(res => {
                        setLoading(false);
                        if (res.status) {
                            toast.success(l.pat_crt_succ, {
                                position: toast.POSITION.TOP_RIGHT
                            })
                            history.push('/clinic-createusers');
                        }
                    }).catch(err => {
                        setLoading(false);
                        let msg = err?.response?.data?.error?.message ? err.response.data.error.message : err?.response?.data?.error ? err.response.data.error : l.unable_crt_patient;
                        toast.error(msg, {
                            position: toast.POSITION.TOP_RIGHT
                        })
                        setErrorMsg(msg)
                    });
                }
            }
            else {
                if (errorMsg != null) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }
            }
        } catch (err) {
            setLoading(false);
            toast.error(err.errorMessage, {
                position: toast.POSITION.TOP_RIGHT
            })
            setErrorMsg(l.went_worng_pls_try_again)
        }
    }

    const handleVerify = () => {
        setopenPopup(prevState => !prevState);
        history.push('/admin-users/patient');
        toast.success("Patient created successfully", {
            position: toast.POSITION.TOP_RIGHT
        })
    }
    // const handleReferredBy = (e) =>{
    //     let _error = {};
    //     let returnValue = true;
        
    //     if (!validateLetters(referredBy)) {
    //             _error['referredBy'] = l.pls_ent_letters_rBy
    //             returnValue = false;
    //         }
    //     else{
    //         setReferredBy(e.target.value)
    //     }
    // }


    console.log('error==', error);


    return (
        loading ? <Loader /> : <Fragment>
            <div className="formCol">

                <div className="formListGroup">
                    {errorMsg &&
                        <div className="errorBox">
                            <small className="errorTxt">{errorMsg}</small>
                        </div>
                    }
                    <div className="colBlock">
                        <form onSubmit={handleCreatePatient}>
                            <div className="rowBlock">
                                <div className={`${error?.title && 'pdT16'} inputRowGroup flex0 mrgRight8`}>
                                    <small className="inpLabel">{l.label_title}<span className="redTxt">*</span>:</small>
                                    <AddrDropDown
                                        placeholder={l.select_title}
                                        items={titlesList}
                                        value={title}
                                        // error={error && error?.title}
                                        // errorMsg={error?.title}
                                        onChange={(e) => {
                                            setError(prevError => ({
                                                ...prevError,
                                                title: ''
                                              }));
                                            setTitle(e.target.value)}}
                                    />
                                    {(error && error?.title) && <span className="inputErrorMsg">{error?.title}</span>}
                                </div>
                                
                                <div className={`${error?.firstName && 'pdT16'} inputRowGroup`}>
                                    <small className="inpLabel">{l.inp_fname}<span className="redTxt">*</span>:</small>
                                    <InputField
                                        name="firstName"
                                        placeholder={l.inp_fname}
                                        type="text"
                                        value={firstName}
                                        // error={error && error?.firstName}
                                        // errorMsg={error?.firstName}
                                        maxLength="30"
                                        onChange={(e) => {
                                            setError(prevError => ({
                                                ...prevError,
                                                firstName: ''
                                              }));
                                            setfirstName(e.target.value)}}
                                    />
                                    {(error && error?.firstName) && <span className="inputErrorMsg">{error?.firstName}</span>}
                                </div>
                            </div>
                            <small className="inpLabel">{l.inp_lname}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.inp_lname}
                                name="lastName"
                                type="text"
                                value={lastName}
                                error={error && error?.lastName}
                                errorMsg={error?.lastName}
                                maxLength="30"
                                onChange={(e) =>{ 
                                    setError(prevError => ({
                                        ...prevError,
                                        lastName: ''
                                      }));
                                    setLastName(e.target.value)}}
                            />
                            <small className="inpLabel">{l.label_gender}<span className="redTxt">*</span>:</small>
                            <div className="inputRowFeild">
                                <div className="hozRadioGroup">
                                    <div className={gender === "male" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="male" name="gender" value="male" label={l.male} checked={gender === "male" ? true : false} 
                                        onChange={(e) => {
                                            setError(prevError => ({
                                                ...prevError,
                                                gender: ''
                                              }));
                                              setGender(e.target.value)}} />
                                        {/* <img className={gender === "M" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/male.png" alt="gendericon" /> */}
                                        {/* <span >{l.male}</span> */}
                                    </div>
                                    <div className={gender === "female" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="female" name="gender" value="female" label= {l.female} checked={gender === "female" ? true : false} 
                                        onChange={(e) => {
                                            setError(prevError => ({
                                                ...prevError,
                                                gender: ''
                                              }));
                                              setGender(e.target.value)}} />
                                        {/* <img className={gender === "F" ? "imgIcon Sm" : "imgIcon invertGray Sm"} src="/images/icons/female.png" alt="gendericon" /> */}
                                        {/* <span >{l.female}</span> */}
                                    </div>
                                    <div className={gender === "others" ? "radioBtnItem radioBtnItemActive" : "radioBtnItem"} >
                                        <Radio id="others" name="gender" value="others" label={l.others} checked={gender === "others" ? true : false} 
                                        onChange={(e) => {
                                            setError(prevError => ({
                                                ...prevError,
                                                gender: ''
                                              }));
                                              setGender(e.target.value)}} />
                                        {/* <span>{l.others}</span> */}
                                    </div>
                                </div>
                                {(error && error.gender) && <span className="inputErrorMsg">{error?.gender}</span>}
                            </div>
                            <small className="inpLabel">{l.dob}<span className="redTxt">*</span>:</small>
                            <div className="inputBox alignCenter">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker fullWidth
                                        className="pickerInput"
                                        inputVariant="outlined"
                                        value={dob}
                                        onChange={(date) => setDob(date && date.valueOf())}
                                        animateYearScrolling
                                        placeholdertext={l.dob}
                                        format="dd/MM/yyyy"
                                        maxDate={new Date()}
                                    />
                                    {/*<div className="inputIconBox"><img src="/images/icons/date.png" className="invertGray" alt="date"/></div>*/}
                                </MuiPickersUtilsProvider>
                            </div>
                            {(error && error?.dob) && <span className="inputErrorMsg">{error?.dob}</span>}
                            {/* <small className="inpLabel">{l.civil_number}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.civil_number}
                                name="lastName"
                                type="text"
                                value={civilNumber}
                                onChange={(e) => setCivilNumber(e.target.value)}
                            /> */}
                            <small className="inpLabel">{l.email_address}<span className="redTxt">*</span>:</small>
                          {pId ?
                            <div className="pTxt">{email}</div> :
                            <InputField
                                placeholder={l.email_address}
                                type="email"
                                value={email.replaceAll(' ','').toLowerCase()}
                                error={error && error?.email}
                                errorMsg={error?.email}
                                maxLength="50"
                                onChange={(e) => 
                                    {setError(prevError => ({
                                        ...prevError,
                                        email: ''
                                    }));
                                    setEmail(e.target.value)}}
                            />
                            }
                                <small className="inpLabel">{l.edit_phone_no}<span className="redTxt">*</span>:</small>
                                <div className="inputBox colBlock nopdng">
                                    <PhoneInput className="customPkgInput nopdng"
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry="IN"
                                        value={phone}
                                        maxLength="17"
                                        onChange={(value) => {
                                            setError(prevError => ({
                                                ...prevError,
                                                phone: ''
                                            }));
                                            setPhone(value);
                                        }}
                                    />
                                    <label>{props.label}</label>
                                    {(error && error?.phone) && <span className="inputErrorMsg">{error?.phone}</span>}
                                </div>
                            <small className="inpLabel">{l.select_bldgrp}<span className="redTxt">*</span>:</small>
                            <AddrDropDown
                                placeholder={l.select_bldgrp}
                                items={bloodgroups}
                                value={decodeURIComponent(bloodgroup)}
                                // error={error && error?.title}
                                // errorMsg={error?.title}
                                onChange={(e) => {
                                    setError(prevError => ({
                                        ...prevError,
                                        bloodgroup: ''
                                      }));
                                      setBloodgruop(encodeURIComponent(e.target.value))}}
                            />
                            {(error && error?.bloodgroup) && <span className="inputErrorMsg">{error?.bloodgroup}</span>}
                            <small className="inpLabel">{l.referred_by}:</small>
                            <InputField
                                placeholder={l.referred_by}
                                type="tel"
                                name="referredBy"
                                value={referredBy}
                                error={error && error.referredBy}
                                errorMsg={error.referredBy}
                                maxLength="30"
                                onChange={(e) =>{ 
                                    setError(prevError => ({
                                        ...prevError,
                                        referredBy: ''
                                      }));
                                    setReferredBy(e.target.value)}}
                                // onChange={handleReferredBy}
                            />
                            <small className="inpLabel">{l.pat_address}:</small>
                            <InputField
                                placeholder={l.pat_address}
                                type="text"
                                value={address}
                                error={error && error?.address}
                                errorMsg={error?.address}
                                maxLength="100"
                                onChange={(e) => setAddress(e.target.value)}
                            />
                            <small className="inpLabel">{l.select_country}:
                            {/* <span className="redTxt">*</span> */}
                            </small>
                            <AddrDropDown
                                // placeholder={l.select_country}
                                items={countriesList}
                                value={country}
                                error={error && error?.country}
                                errorMsg={error?.country}
                                onChange={(e) => setCountry(e.target.value)}
                            />
                            <small className="inpLabel">{l.select_state}:
                            {/* <span className="redTxt">*</span> */}
                            </small>
                            <AddrDropDown
                                placeholder={l.select_state}
                                items={states}
                                value={state}
                                error={error && error?.state}
                                errorMsg={error?.state}
                                onChange={(e) => setState(e.target.value)}
                            />
                            <small className="inpLabel">{l.select_city}:
                            {/* <span className="redTxt">*</span> */}
                            </small>
                            <AddrDropDown
                                placeholder={l.select_city}
                                items={cities}
                                value={city}
                                error={error && error?.city}
                                errorMsg={error?.city}
                                onChange={(e) => setCity(e.target.value)}
                            />

                            <small className="inpLabel">{l.edit_pin}:
                            {/* <span className="redTxt">*</span> */}
                            </small>
                            <InputField
                                placeholder={l.edit_pin}
                                type="text"
                                maxLength={15}
                                value={pincode}
                                error={error && error?.pincode}
                                errorMsg={error?.pincode}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        setPincode(value); // Only set value if it is numeric
                                    }
                                }}
                            />
                            {/* {role !== "C" && <Fragment>
                                <small className="inpLabel">{l.edit_clc_domain_name}<span className="redTxt">*</span>:</small>
                                <InputField
                                    placeholder={l.edit_clc_domain_name}
                                    type="text"
                                    value={domainName}
                                    onChange={(e) => setDomainName(e.target.value)}
                                />
                            </Fragment>} */}
                            {/* <InputField
                            placeholder={l.pass}
                            type="password"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <InputField
                            placeholder={l.confirm_pwd}
                            type="password"
                            onChange={(e) => setConfirmPwd(e.target.value)}
                        />*/}
                            {role === "SA" && !pId && <Fragment>
                                <small className="inpLabel">{l.ass_admin}<span className="redTxt">*</span>:</small>
                                <DropDown
                                    placeholder={l.ass_admin}
                                    items={admins}
                                    value={adminId}
                                    error={error && error?.adminId}
                                    errorMsg={error?.adminId}
                                    onChange={(e) => setAdminId(e.target.value)}
                                />
                            </Fragment>}
                            {role !== 'C' && !pId && <Fragment>
                                <small className="inpLabel">{l.ass_to}<span className="redTxt">*</span>:</small>
                                <DropDown
                                    placeholder={l.ass_to}
                                    items={clinics}
                                    value={clinic}
                                    error={error && error?.clinic}
                                    errorMsg={error?.clinic}
                                    onChange={(e) => setClinic(e.target.value)}
                                />
                            </Fragment>}
                            <div className="crdBtnContainer">
                                <div className="rowBlock">
                                    <Button
                                        label={l.cancel}
                                        type='outLine'
                                        size='md'
                                        onClick={handleCancel}
                                    />
                                    <Button
                                        buttonType='submit'
                                        disabled={!validateForm}
                                        label={pId ? l.update_pat : l.create_pat}
                                        type='primary'
                                        size='md'
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {openPopup &&
                <VerifyPopup openVerify={openPopup} phone={phone.trim()} closePopup={handleVerify} handleVerify={handleVerify} />}
        </Fragment>
    )
}

export default CreatePatientForm;
